import { render, staticRenderFns } from "./CreateProfileStep2.vue?vue&type=template&id=5b439ed0&"
import script from "./CreateProfileStep2.vue?vue&type=script&lang=ts&"
export * from "./CreateProfileStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
